<template>
    <v-layout row wrap pa-5 mt-4 light class="white-bg">
        <v-flex xs12>
            Gallerie wechseln:
            <v-select
                    :items="galleryNames"
                    v-model="activeGalName"
                    label="Gallerie"
            ></v-select>
        </v-flex>
        <v-flex xs12 md3 v-for="(img,key) in pics[activeGalName]" :key="key">
            <v-card light class="py-1 px-4 ma-1">
                <v-card-title class="headline">{{img.title}}</v-card-title>
                <v-img :src="$helper.imgServerUrl() + img.path" :alt="img.title"></v-img>
                <v-card-text>
                    {{img.description}}
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>


<script>
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "Gallery",
        directives: {
            Resize, Scroll
        },
        data() {
            return {
                activeGalleryPics: [],
                galleryNames: [/*{name: '', updated_at: '', created_at: ''}*/],
                activeGalName: '',
                pics: {}
            }
        },
        methods: {
            getGalleryNames() {
                this.$http.get(this.$helper.apiUrl() + '/gallery/names').then(({body}) => {
                    body.forEach(gal => {
                        this.galleryNames.push(gal.name)
                        this.pics[gal.name] = []
                        // console.log(this.pics)
                    })
                    this.getPics()
                })
            },
            getPics() {
                this.$http.get(this.$helper.apiUrl() + '/gallery/pics').then(({body}) => {
                    // console.lg(body, gal_name, this.pics, this.pics[gal_name])
                    body.forEach(pic => this.pics[pic.gal_name].push(pic))
                    this.activeGalleryPics = this.pics[this.galleryNames[0]]
                    this.activeGalName = this.galleryNames[0]
                })
            },
        },
        created() {
            this.getGalleryNames()
        },
        mounted() {
            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)
        }
    }
</script>

